import React, { useState } from 'react';
import { Button, Input, Modal } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { ModalStyled } from './ModalStyled';
import { requestReopen } from '../../../services/repository/payrollRepository';
import mostrarErro from '../../../services/util/error-handler';

const { TextArea } = Input;

const TextoModal = styled.p`
  font-size: 12px;
  color: #a3a4a5;
`;

function ModalReaberturaGestor({ visible = false, onSuccessful, onError, onCancel, payroll = {} }) {
  const [justification, setJustification] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmClick = async () => {
    try {
      setIsLoading(true);
      await requestReopen(payroll.id, justification);
      onSuccessful(payroll);

      Modal.success({
        title: 'Sucesso',
        content: (
          <p>
            Pedido reaberto com sucesso, em instantes o gestor responsável receberá um e-mail para reenviar o pedido.
          </p>
        ),
      });
    } catch (err) {
      mostrarErro(err);
      onError(payroll, err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalStyled
      open={visible}
      title="Reabertura"
      onOk={handleConfirmClick}
      onCancel={onCancel}
      closable={false}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => handleConfirmClick(justification)}
          loading={isLoading}
        >
          <CustomText color="var(--system-bg)">Enviar</CustomText>
        </Button>,
        <Button
          key="back"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancelar
        </Button>,
      ]}
    >
      <TextoModal>Para finalizar o pedido, justifique o motivo da reabertura:</TextoModal>
      <TextArea
        rows={5}
        value={justification}
        onChange={({ target: { value } }) => setJustification(value)}
      />
    </ModalStyled>
  );
}

ModalReaberturaGestor.propTypes = {
  visible: PropTypes.bool,
  onSuccessful: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  payroll: PropTypes.shape(),
};

export default ModalReaberturaGestor;
